'use client';

import { FC, useState } from 'react';
import { useTranslations } from 'next-intl';
import { WLAS_TABS } from './constants';
import { WlasTab, WlasTabBar } from './styled';
import { WlasBillingTab } from './tabs/billing';
import { WlasConfigTab } from './tabs/configuration';

const TAB_CONTENT: Record<string, FC> = {
  configuration: WlasConfigTab,
  billing: WlasBillingTab,
};

export const WlasTabsPanel: FC = () => {
  const t = useTranslations('wlasWidget');
  const [activeIndex, setActiveIndex] = useState(0);
  const activeKey = WLAS_TABS[activeIndex]?.key;
  const ActiveTab = activeKey !== undefined ? TAB_CONTENT[activeKey] : null;

  return (
    <>
      <WlasTabBar value={activeIndex} onChange={(_, i) => setActiveIndex(i)}>
        {WLAS_TABS.map((tab) => (
          <WlasTab key={tab.key} label={t(tab.labelKey)} disabled={tab.disabled} />
        ))}
      </WlasTabBar>

      {ActiveTab && <ActiveTab />}
    </>
  );
};
